import type { ProjectStatus } from '~/constants/domain'

export interface ProjectMetadata {
  name: string
  value: string
  url?: string
}

export class Project {
  constructor(
    public title: string,
    public id: string,
    public url: string,
    public projectStatus: ProjectStatus,
    public metadata: Array<ProjectMetadata>,
  ) {}
}

export class PersonalProjects {
  constructor(
    public inProgress: Array<Project>,
    public definitelyFinished: Array<Project>,
  ) {}
}
